import React, { memo } from 'react';
import { Box, Text } from 'components/Wrapped';
import styles from './DemandPercentLine.module.scss';

const DemandPercentLine = memo(({ buyPercentValue, sellPercentValue }) => (
  <Box pad="none" direction="row" height="30px" round="20px" className={styles.percentLineWrap}>
    <Box pad="none" width="50%" className={styles.buyPercentLine}>
      <Box pad="5px" align="center" direction="row" gap="8px" height="100%">
        <Box background="#46B08E" pad="none" round="50%" align="center" justify="center" height="20px" width="20px">
          <Text color="white" size="12px" weight={500} style={{ lineHeight: '16px' }}>
            B
          </Text>
        </Box>
        <Text color="white" size="12px" weight={500} style={{ lineHeight: '16px' }}>
          {buyPercentValue}%
        </Text>
      </Box>
    </Box>
    <Box pad="none" width="50%" className={styles.sellPercentLine}>
      <Box pad="5px" align="center" justify="end" direction="row" gap="8px" height="100%">
        <Text color="white" size="12px" weight={500} style={{ lineHeight: '16px' }}>
          {sellPercentValue}%
        </Text>
        <Box background="#C55445" pad="none" round="50%" align="center" justify="center" height="20px" width="20px">
          <Text color="white" size="12px" weight={500} style={{ lineHeight: '16px' }}>
            S
          </Text>
        </Box>
      </Box>
    </Box>
  </Box>
));

export default DemandPercentLine;
